import React, {useEffect} from 'react';
import {HtmlParse} from 'utils';
import linksColumn from './links';
import SocialLinks from './SocialLinks';
import List from './List';
import MethodPay from './MethodPay';
import PubSub from 'services/PubSub';
import Link from 'components/Link';
import Accordion from 'components/Accordion';
import logoPrime from 'images/footer/jumbo-prime.svg'
import style from './style.scss'; //NOSONAR

const Navigation = () => {

    useEffect(() => {
        PubSub.dispatch('accordion-footer', {
            title: linksColumn[0].title,
        })
    }, [])

    const items = linksColumn.map((item, i) => {
        return {
            title: item.title,
            content: <List list={item} key={i}/>
        }
    });

    return (
        <section className={'footer-nav open'}>
            <nav className={'center'}>
                <Accordion content={items} withQty={true}/>
            </nav>
            <div className="footer-aside">
                <Link className="footer-aside-prime" to={'https://jumboprime.cl/'} target='_blank'>
                    <span className="accordion-title">Descubre</span>
                    <span className="footer-aside-prime-img">
                        {HtmlParse(logoPrime)}
                    </span>
                </Link>
                <div className="footer-aside-prime">
                    <span className="accordion-title">Síguenos</span>
                    <SocialLinks />
                </div>
                <div className="footer-aside-prime">
                    <span className="accordion-title">Medios de pago</span>
                    <MethodPay />
                </div>
            </div>
        </section>
    )
}

export default Navigation;
